<template>
    <div class="list">
        <div class="d-flex justify-content-between align-items-center">
            <div class="label" v-if="!!label">{{ label }}</div>
            <div class="counter">{{ selected.length }} de {{ options.length }} seleccionados</div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <div class="selectors"><a href="#" @click.prevent="selectAll">Todos</a> | <a href="#" @click.prevent="selectNone">Ninguno</a></div>
            <div class="search"><app-form-input size="sm" placeholder="Buscar" v-model="search"></app-form-input></div>
        </div>
        <div class="ms-list-items" v-if="!busy">
            <div class="list-group d-flex flex-column">
                <div
                    class="ms-list-group-item"
                    href="#"
                    v-for="(option, index) in finalOptions"
                    :key="index"
                    :class="isSelected(option) ? 'selected' : ''"
                    @click.prevent="select(option)"
                >
                    {{ option[textField] }}
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center align-items-center" v-else>
            <app-preloader></app-preloader>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        textField: {
            type: String,
            default: 'name',
        },
        valueField: {
            type: String,
            default: 'id',
        },
        object: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        busy: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        selected: [],
        search: '',
    }),
    computed: {
        finalOptions() {
            if (!this.search) return this.options.slice(0, 200)

            return this.options.filter((item) => item[this.textField].toLowerCase().includes(this.search.toLowerCase()))
        },
    },
    methods: {
        select(option) {
            const isSelected = this.isSelected(option)
            const selected = this.selected.filter((item) => item[this.valueField] !== option[this.valueField])
            !isSelected && selected.push(option)
            this.selected = selected
            this.$emit('input', this.object ? this.selected : this.selected.map((item) => item[this.valueField]))
        },
        isSelected(option) {
            return this.selected.map((item) => item[this.valueField]).includes(option[this.valueField])
        },
        selectAll() {
            this.selected = this.options.slice(0)
            this.$emit('input', this.object ? this.selected : this.selected.map((item) => item[this.valueField]))
        },
        selectNone() {
            this.selected = []
            this.$emit('input', this.object ? this.selected : this.selected.map((item) => item[this.valueField]))
        },
    },
}
</script>

<style scoped>
.ms-list-items {
    /* max-height: 200px; */
    overflow: auto;
}
.multiselector-item {
    max-height: 20px;
}

.ms-list-group-item {
    border: 1px solid lightgray;
    border-bottom: none;
    padding: 2px 10px;
    cursor: pointer;
}

.ms-list-group-item:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}
.ms-list-group-item:last-child {
    border-bottom: 1px solid lightgray;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.selected {
    background-color: #6e707e;
    color: white;
    font-weight: bold;
}
</style>
